import { List } from "semantic-ui-react";
import React from "react";

export function HeaderItem({ icon, label, value }) {
  return (
    <List>
      <List.Item>
        <List.Icon name={icon} />
        <List.Content>
          <List.Header style={{ wordBreak: "break-word" }}>
            {value ? value : "-"}
          </List.Header>
          <List.Description>{label}</List.Description>
        </List.Content>
      </List.Item>
    </List>
  );
}
